/**
 * calendar.js — Jun-2026 (User-Wunsch).
 *
 * Rein clientseitige Kalender-Helfer für die Werkstatt-Termin-Bestätigung:
 *   • buildICS(event)      → ICS-Text (RFC 5545)
 *   • downloadICS(name, e) → löst den .ics-Download per Blob aus
 *   • googleCalendarUrl(e) → Google-Calendar-„TEMPLATE"-URL
 *
 * Erwartetes Event-Objekt: { title, description, location, start: Date, end: Date }.
 */

function pad(n) {
    return String(n).padStart(2, "0");
}

// „Floating" lokale Zeit (ohne Z) → der Termin erscheint in der Zeitzone des
// Nutzers exakt so, wie er gebucht wurde.
function fmtLocal(d) {
    return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;
}

// UTC-Zeitstempel (mit Z) — für DTSTAMP und Google-Calendar-Parameter.
function fmtUTC(d) {
    return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;
}

function escapeICS(s) {
    return String(s || "")
        .replace(/\\/g, "\\\\")
        .replace(/;/g, "\\;")
        .replace(/,/g, "\\,")
        .replace(/\n/g, "\\n");
}

export function buildICS({ title, description, location, start, end }) {
    const uid = `${Date.now()}-${Math.random().toString(36).slice(2)}@twowheels`;
    return [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//TwoWheels//Werkstatt//DE",
        "CALSCALE:GREGORIAN",
        "METHOD:PUBLISH",
        "BEGIN:VEVENT",
        `UID:${uid}`,
        `DTSTAMP:${fmtUTC(new Date())}`,
        `DTSTART:${fmtLocal(start)}`,
        `DTEND:${fmtLocal(end)}`,
        `SUMMARY:${escapeICS(title)}`,
        `DESCRIPTION:${escapeICS(description)}`,
        `LOCATION:${escapeICS(location)}`,
        "END:VEVENT",
        "END:VCALENDAR",
    ].join("\r\n");
}

export function downloadICS(filename, event) {
    const blob = new Blob([buildICS(event)], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function googleCalendarUrl({ title, description, location, start, end }) {
    const params = new URLSearchParams({
        action: "TEMPLATE",
        text: title || "",
        details: description || "",
        location: location || "",
        dates: `${fmtUTC(start)}/${fmtUTC(end)}`,
    });
    return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

// Lokale ISO-8601-Zeit (ohne Z) — Outlook interpretiert sie als Ortszeit.
function fmtLocalISO(d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:00`;
}

// Outlook / Office-365 (Geschäftskonto) „compose"-Deeplink.
export function outlookCalendarUrl({ title, description, location, start, end }) {
    const params = new URLSearchParams({
        path: "/calendar/action/compose",
        rru: "addevent",
        subject: title || "",
        body: description || "",
        location: location || "",
        startdt: fmtLocalISO(start),
        enddt: fmtLocalISO(end),
    });
    return `https://outlook.office.com/calendar/0/deeplink/compose?${params.toString()}`;
}
